/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, companyName: NonNullable<unknown> }} Auth_Youvebeeninvitedby3Inputs */

const en_auth_youvebeeninvitedby3 = /** @type {(inputs: Auth_Youvebeeninvitedby3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You've been invited by ${i?.name} to join the ${i?.companyName} platform. We require our users to create and log in with an OKTA account. This ensures a secure network for your investments.`)
};

/**
* | output |
* | --- |
* | "You've been invited by {name} to join the {companyName} platform. We require our users to create and log in with an OKTA account. This ensures a secure netwo..." |
*
* @param {Auth_Youvebeeninvitedby3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_youvebeeninvitedby3 = /** @type {((inputs: Auth_Youvebeeninvitedby3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Youvebeeninvitedby3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_youvebeeninvitedby3(inputs)
});
export { auth_youvebeeninvitedby3 as "auth_youveBeenInvitedBy" }